import { render, staticRenderFns } from "./AssignRulesListItem.vue?vue&type=template&id=95e9633a&"
import script from "./AssignRulesListItem.vue?vue&type=script&lang=ts&"
export * from "./AssignRulesListItem.vue?vue&type=script&lang=ts&"
import style0 from "./AssignRulesListItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports